interface Ifoot {
  apiData: any;
}
const TFoot = ({ apiData }: Ifoot) => {
  const totalDownTime = apiData.reduce((sum:any,item:any)=>sum+ +((item?.downTime/60)),0).toFixed(2)
  return (
    <tfoot>
      <tr style={{ background: 'yellow' }}>
        <th colSpan={3}>Total</th>
        <th>{totalDownTime}</th>
        <th></th>
        <th></th>
      </tr>
    </tfoot>
  );
};

export default TFoot;
